export const userStatuses = {
  online: 'online',
  offline: 'offline'
}
